import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import type ArticleFootnote from "@/src/_types/Article/article-footnote";
import { HEADING_SIZE } from "@/src/components/common/broadsheet/tokens";

const ArticleFootnotes = ({ footnotes }: { footnotes: ArticleFootnote[] }) => (
  <Box component="section" role="doc-endnotes" sx={{
    mt: 1
  }}>
    <Typography component="h2" color="primary" sx={{
      mb: 2
    }}>
      <SpanTypography sx={{
        fontSize: HEADING_SIZE.section
      }}>Footnotes</SpanTypography>
    </Typography>
    <Box>
      <List sx={{ py: 0 }}>
        {footnotes.map((footnote: ArticleFootnote, index: number) => (
          <ListItem key={`footnote-${index}`} sx={{ py: 0 }}>
            <ListItemText sx={{ my: 0 }}>
              <Typography
                sx={{
                  display: {
                    xs: "flex",
                    sm: "flex",
                    md: "block",
                  },

                  alignItems: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "center",
                  },

                  flexDirection: {
                    xs: "column",
                    sm: "column",
                    md: "row",
                  }
                }}>
                <SpanTypography
                  sx={{
                    display: {
                      xs: "flex",
                      sm: "flex",
                      md: "inline",
                    },

                    alignItems: "center"
                  }}>
                  <SpanTypography sx={{
                    display: "inline"
                  }}>
                    <SpanTypography
                      sx={{
                        fontWeight: "bold",
                        mr: 0.25
                      }}>
                      {footnote.label}
                    </SpanTypography>
                  </SpanTypography>
                </SpanTypography>
                <SpanTypography
                  variant="body1"
                  sx={{
                    display: "inline",
                    fontSize: "1rem"
                  }}>
                  {ReactHtmlParser(footnote.content)}
                </SpanTypography>
              </Typography>
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Box>
  </Box>
);

export default ArticleFootnotes;
